"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ListTableConnector = props => {
  const {
    children,
    entity,
    [props.entity.plural]: store,
    schema,
    onLimit,
    onFlip,
    onJump,
    onSelect,
    onSelectAll,
    onDelete,
    onSort
  } = props;
  return _react.default.cloneElement(children, {
    //Table
    columns: (0, _helpers.mapSchemaToColumns)(schema),
    values: store.list.data,
    selection: store.list.selection,
    fetching: store.list.fetching,
    fetched: store.list.fetched,
    onClick: id => `/${entity.plural}/${id}`,
    onSelect,
    onSelectAll,
    onDelete,
    onSort,
    // TablePagination
    limit: store.list.limit,
    limits: store.list.limits,
    page: store.list.page,
    total: store.list.total,
    onLimit,
    onFlip,
    onJump
  });
};
var _default = exports.default = ListTableConnector;
module.exports = exports.default;